require("!!C:\\Users\\benns\\code\\web\\intonation_angular\\angular-cli\\intonationstrainer\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\benns\\code\\web\\intonation_angular\\angular-cli\\intonationstrainer\\node_modules\\raw-loader\\index.js!C:\\Users\\benns\\code\\web\\intonation_angular\\angular-cli\\intonationstrainer\\node_modules\\source-map-loader\\index.js!C:\\Users\\benns\\code\\web\\intonation_angular\\angular-cli\\intonationstrainer\\src\\envelope-generator.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/envelope-generator.js
// module id = 383
// module chunks = 2